import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { DisruptionProtectionStateV1 } from "./types";

export const getAirDisruptionMachineV1 = (config: ChildMachineConfig) => ({
  initial: DisruptionProtectionStateV1.route,
  states: {
    [DisruptionProtectionStateV1.route]: {
      always: [
        {
          target: DisruptionProtectionStateV1.addProduct,
          cond: GuardTypes.hasDisruptionOfferAndEnabled,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [DisruptionProtectionStateV1.addProduct]: {
      always: [
        {
          actions: ActionTypes.addDisruptionProducts,
          target: config.nextState,
        },
      ],
    },
  },
});
